module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/kea-saga/~/babel-runtime/core-js/object/assign.js
// module id = 215
// module chunks = 2